module.exports = __webpack_public_path__ + "static/media/aika-lose.0335c30d.jpg";